import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';  // Ensure this is imported
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownConfig } from '../../config/dropdown-config';

@Component({
  selector: 'app-single-multi-selection',
  standalone: true,
  imports: [DropdownModule, MultiSelectModule, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './single-multi-selection.component.html',
  styleUrls: ['./single-multi-selection.component.scss']
})
export class SingleMultiSelectionComponent implements OnInit {

  @Input() config!: DropdownConfig;
  @Output() selectionChange = new EventEmitter<any>();

  errorMessage: string | null = null;

  ngOnInit(): void {
    // Initialize formControl properly if it's undefined
    if (!this.config.formControl) {
      this.config.formControl = new FormControl(null);
    }

    // Handling form control validation on init
    if (this.config.formControl?.errors) {
      this.errorMessage = this.getErrorMessage();
    }
  }

  // Helper method to get error message for validation
  getErrorMessage(): string {
    const errors: any = this.config.formControl?.errors;
    if (errors?.required) {
      return 'This field is required';
    }
    return '';
  }

  // Emits the selected value to parent component
  onSelectionChange(event: any): void {
    this.selectionChange.emit(event.value);
  }
}
